
import { GENERIC_ERROR_DESCRIPTION } from '@/constants';
import { BotMixin } from '@/mixins/BotMixin';
import isEqual from 'fast-deep-equal/es6';
import { WhatsAppPlatformData, SupportedPlatform } from 'ignite360-core';
import { mixins } from 'vue-class-component';
import { Component, Watch } from 'vue-property-decorator';

type WhatsAppSettings = Pick<
  WhatsAppPlatformData,
  'enableMessaging' | 'phoneNumberId' | 'pageAccessToken' | 'businessAccountId'
>;

@Component({
  name: 'whatsapp-settings-card',
})
export default class WhatsAppSettingsCard extends mixins(BotMixin) {
  whatsAppSettings = this.resetValue();

  isSubmitting = false;

  get settingsHaveChanged(): boolean {
    return !isEqual(this.whatsAppSettings, this.resetValue());
  }

  async onSubmit() {
    this.isSubmitting = true;
    try {
      await this.$updateBotPlatform({
        id: this.bot.id,
        platform: SupportedPlatform.WhatsApp,
        data: this.whatsAppSettings,
      });
      this.$notify.success('Successfully updated WhatsApp-settings');
    } catch (e) {
      this.$notify.error({
        title: 'Updating WhatsApp-settings failed',
        description: GENERIC_ERROR_DESCRIPTION,
      });
    } finally {
      this.isSubmitting = false;
    }
  }

  @Watch('bot', { immediate: true, deep: true })
  private reset() {
    this.whatsAppSettings = this.resetValue();
  }

  private resetValue(): WhatsAppSettings {
    return {
      enableMessaging: this.bot.platformData.whatsApp.enableMessaging,
      phoneNumberId: this.bot.platformData.whatsApp.phoneNumberId,
      pageAccessToken: this.bot.platformData.whatsApp.pageAccessToken,
      businessAccountId: this.bot.platformData.whatsApp.businessAccountId,
    };
  }
}
